import { BidType } from '../types/bid.type'

export class Bid {
  public constructor(public readonly bidType: BidType) {}

  public getBidName(): string {
    if (this.bidType === 'Two') {
      return $localize`:Bid name:Two`
    }

    if (this.bidType === 'Three') {
      return $localize`:Bid name:Three`
    }

    if (this.bidType === 'Four') {
      return $localize`:Bid name:Four`
    }

    if (this.bidType === 'Five') {
      return $localize`:Bid name:Five`
    }

    if (this.bidType === 'Bettler') {
      return $localize`:Bid name:Six`
    }

    if (this.bidType === 'NoTrump') {
      return $localize`:Bid name:Seven`
    }

    if (this.bidType === 'Hand') {
      return $localize`:Bid name:Hand`
    }

    if (this.bidType === 'BettlerHand') {
      return $localize`:Bid name:Bettler`
    }

    if (this.bidType === 'NoTrumpHand') {
      return $localize`:Bid name:No Trump`
    }

    if (this.bidType === 'TwoHand') {
      return $localize`:Bid name:Spades`
    }

    if (this.bidType === 'ThreeHand') {
      return $localize`:Bid name:Diamonds`
    }

    if (this.bidType === 'FourHand') {
      return $localize`:Bid name:Hearts`
    }

    if (this.bidType === 'FiveHand') {
      return $localize`:Bid name:Clubs`
    }

    throw new Error(`Unable to get bid name for bid ${this.bidType}`)
  }

  public isHandType(): boolean {
    return (
      this.bidType === 'Hand' ||
      this.bidType === 'TwoHand' ||
      this.bidType === 'ThreeHand' ||
      this.bidType === 'FourHand' ||
      this.bidType === 'FiveHand' ||
      this.bidType === 'BettlerHand' ||
      this.bidType === 'NoTrumpHand'
    )
  }
}
